// noinspection JSUnusedGlobalSymbols // All functions are used!

export default {
    methods: {
        apiRequest: async function(method, endpoint, data = null, sendSession = true, fileUpload = false, raw = false) {
            const allowedMethods = ['POST', 'GET', 'PATCH', 'PUT', 'DELETE'];
            method = method.toUpperCase();
            if(!allowedMethods.includes(method)) {
                console.error("Forbidden method used!")
            }

            // noinspection JSUnresolvedVariable
            let url = this.apiBaseUrl + endpoint;
            const init = {
                method: method,
                cache: 'no-cache',
                headers: {},
                redirect: 'follow',
                referrerPolicy: 'no-referrer',
            }

            if(sendSession) {
                init.headers.Authorization = 'Bearer ' + this.sessionKey;
            }

            if(method !== "GET" && method !== "DELETE") {
                if(!fileUpload)
                    init.body = JSON.stringify(data);
                else
                    init.body = data;
                if(!fileUpload)
                    init.headers['Content-Type'] = 'application/json';
            }

            const response = await fetch(url, init);
            const ret = {rawResponse: response, status: response.status, success: false};

            if(response.status === 404) {
                return ret;
            }

            if(response.status === 204) {
                ret.success = true;
                return ret;
            }

            if(raw) {
                return response;
            }


            let cnt;
            try {
                cnt = await response.json();
            } catch(err) {
                if(response.status === 201) {
                    ret.success = true;
                    return ret;
                }

                console.error(err);
                return ret;
            }
            ret.cnt = cnt;

            if((response.status === 403 && "error" in cnt
                    && (cnt.id === "sessionUnknown" || cnt.id === "sessionExpired"))
                || response.status === 401) {
                this.destroySession();
                return ret;
            }

            if(response.status === 201 || response.status === 200) {
                if(typeof cnt === "object" && cnt !== null) {
                    cnt.success = true;
                }
                return cnt;
            }

            return ret;
        },
        getFormData: function(id) {
            const form = document.getElementById(id);
            const formData = new FormData(form);
            const data = {};
            formData.forEach((value, key) => {
                if(key in data) {

                    if(Array.isArray(data[key])) {
                        data[key].push(value);
                    } else {
                        data[key] = [data[key], value];
                    }
                } else {
                    data[key] = value;
                }
            });
            return data;
        },
        globalValidate: function(event) {
            let parent = this;
            for(let i = 0; i < 10; i++) {
                if("formValid" in parent.$data) {
                    break;
                }
                if(parent.$parent !== null) {
                    parent = parent.$parent;
                } else {
                    break;
                }
            }

            if(!"formValid" in parent.$data) {
                console.warn("formValid not found!");
                return;
            }

            let valid = true;

            let form = event?.target?.form ?? event;
            if(form === null) {
                return;
            }
            if(!("elements" in form)) {
                // console.warn("elements of form not found!");
                return;
            }

            let elements = form.elements;

            for(const el of elements) {
                const ds = el.dataset;
                const val = el.value;


                if("number" in ds) {
                    const numberValue = parseFloat(val.replaceAll(",", "."));
                    if(isNaN(numberValue)) valid = false;

                    if("numberMin" in ds) {
                        if(numberValue < ds.numberMin) {
                            valid = false;
                        }
                    }
                    if("numberMax" in ds) {
                        if(numberValue > ds.numberMax) {
                            valid = false;
                        }
                    }
                }


                if("min" in ds) {
                    if(val.length < parseInt(ds.min, 10)) {
                        valid = false;
                    }
                }
                if("max" in ds) {
                    if(val.length > parseInt(ds.max, 10)) {
                        valid = false;
                    }
                }
                if("enum" in ds) {
                    if(!ds.enum.includes(val)) {
                        valid = false;
                    }
                }
                if("notIn" in ds) {
                    if(ds.notIn.includes(val)) {
                        valid = false;
                    }
                }
                if("hasCustomValidation" in ds && ds.hasCustomValidation === "true") {
                    if(!("customValid" in ds) || ds.customValid !== "true") {
                        valid = false;
                    }
                }

            }

            parent.$data.formValid = valid;
        },
        getSVG(icon) {
            try {
                return require('@/assets/img/svg/icons/' + icon + '.svg');
            } catch(e) {
                console.error("Icon " + icon + " not found!");
            }
        },
        getSVGImage(image) {
            try {
                return require('@/assets/img/svg/' + image);
            } catch(e) {
                console.error("Image " + image + " not found!");
            }
        },
        getImage(image) {
            try {
                return require('@/assets/img/' + image);
            } catch(e) {
                console.error("Image " + image + " not found!");
            }
        },
        confirm(text, heading = false) {
            const model = this.$store.state.confirmationOverlay;
            model.heading = heading;
            model.text = text;
            return new Promise((resolve, ignored_reject) => {
                model.resolve = resolve;
                model.visible = true;
            })
        },
        getItemById(id, data) {
            for(const elKey in data) {
                const el = data[elKey];
                if(el.id === id) {
                    return el;
                }
            }
            return {};
        },
        showAPIError(res, textInput) {
            console.log(res);
            let text = textInput;
            let type = "error";
            switch(res.status) {
                case 400:
                    if(res.cnt.id === "paramConstraint") {
                        type = "warning";
                        text += " " + res.cnt.msg;
                        if("additionalInformation" in res.cnt) {
                            text += " Folgender Constraint wurde nicht eingehalten: "
                                + res.cnt.additionalInformation.key + ": "
                                + res.cnt.additionalInformation.constraints.join(", ");
                        }
                    } else if(res.cnt.id === "missingParameter") {
                        text += " Folgende Eigenschaften fehlen: " + res.cnt.additionalInformation.missing.join(", ");
                    } else if(res.cnt.id === "wrongParamType") {
                        text += " " + res.cnt.msg;
                    } else {
                        text += " " + res.cnt.msg;
                    }
                    break;
                case 403:
                    text = "Fehler! Sie haben nicht die nötigen Rechte, um diese Aktion durchzuführen.";
                    break;
                case 404:
                    type = "warning";
                    text = "Fehler 404: Der angeforderte Inhalt konnte nicht gefunden werden.";
                    break;
                case 409:
                    text = "Conflict! " + res.cnt.id;
                    break;
                case 500:
                    text += "<br /><br />API-Fehler! Siehe JS-Console für weitere Details!";
                    break;
                default:
                    text += " " + (res?.cnt?.msg ?? '');
            }

            this.showNotice({
                type,
                content: text,
            })
        },
        generateRandomString(length = 10) {
            const chars = "abcdefghjkmnpqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ123456789".split('');
            const array = new Uint8Array(length);
            self.crypto.getRandomValues(array);
            let out = "";
            for(const randInt of array) {
                const randIntInValueRange = randInt % chars.length;
                out += chars[randIntInValueRange];
            }
            return out;
        },
        formatDate(date) {
            if(!(date instanceof Date)) {
                date = new Date(date);
            }
            return date.toLocaleDateString(undefined, {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
                weekday: "long",
            });
        },
        formatDateTime(date, withSeconds = false) {
            if(!(date instanceof Date)) {
                date = new Date(date);
            }
            return date.toLocaleDateString(undefined, {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                }) + ', ' +
                date.toLocaleTimeString(undefined, {
                    hour: '2-digit',
                    minute: '2-digit',
                    second: withSeconds ? '2-digit' : undefined,
                }) + ' Uhr';
        },
        formatTime(date) {
            if(!(date instanceof Date)) {
                date = new Date(date);
            }
            return date.toLocaleTimeString(undefined, {
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
            }) + ' Uhr';
        },
        formatSeconds(seconds) {
            const tage = Math.floor(seconds / (3600 * 24));
            const stunden = Math.floor((seconds % (3600 * 24)) / 3600);
            const minuten = Math.floor((seconds % 3600) / 60);
            const sekunden = seconds % 60;

            let ret = minuten.toString().padStart(2, '0') + ':' + sekunden.toString().padStart(2, '0');
            if(stunden > 0 || tage > 0) {
                ret = stunden.toString().padStart(2, '0') + ':' + ret;
            }
            if(tage > 0) {
                ret = tage.toString().padStart(2, '0') + ':' + ret;
            }
            return ret;
        },
        setBreadCrumbs(breadCrumbs) {
            this.$store.state.breadCrumbs = breadCrumbs;
        },
        showNotice(model) {
            this.$store.commit("setToast", model);
        },
        waitForElement(selector, callback) {
            function checkForElement() {
                const element = document.querySelector(selector);

                if(element) {
                    callback(element);
                } else {
                    requestAnimationFrame(checkForElement);
                }
            }

            checkForElement();
        },
        formatMoney(cents) {
            return ((parseInt("" + cents) / 100)
                .toFixed(2) + " €")
                .replaceAll(".", ",");
        },
        getDateForFilename() {
            const now = new Date();

            const year = now.getFullYear();

            const month = String(now.getMonth() + 1).padStart(2, '0');
            const day = String(now.getDate()).padStart(2, '0');

            const hours = String(now.getHours()).padStart(2, '0');
            const minutes = String(now.getMinutes()).padStart(2, '0');
            const seconds = String(now.getSeconds()).padStart(2, '0');

            return `${year}${month}${day}-${hours}${minutes}${seconds}`;
        },
        formatDateForDatetimeLocal(date) {
            const year = date.getFullYear();
            const month = (date.getMonth() + 1).toString().padStart(2, '0');
            const day = date.getDate().toString().padStart(2, '0');
            const hours = date.getHours().toString().padStart(2, '0');
            const minutes = date.getMinutes().toString().padStart(2, '0');

            return `${year}-${month}-${day}T${hours}:${minutes}`;
        },
        formatDateForDateInput(date) {
            if(!(date instanceof Date)) {
                return "";
            }
            const year = date.getFullYear().toString().padStart(4, '0');
            const month = (date.getMonth() + 1).toString().padStart(2, '0');
            const day = date.getDate().toString().padStart(2, '0');

            return `${year}-${month}-${day}`;
        },
        getFileTypeText(content) {
            switch(content.type) {
                case 'folder':
                    return 'Ordner';
                case 'single':
                    switch(content.file.mimeType) {
                        case 'application/pdf':
                            return 'PDF';
                        case 'image/jpg':
                        case 'image/jpeg':
                            return 'Bild (JPG)';
                        case 'image/png':
                            return 'Bild (PNG)';
                        case 'image/svg+xml':
                            return 'Bild (SVG)';
                        case 'video/mp4':
                            return 'Video (MP4)';
                    }
                    return '';
                case 'set':
                    return 'Dateiset';
                case 'generated':
                    return 'Generiertes Medium';
                case 'group':
                    return 'Berechtigungsgruppe';
            }
        },
        getIconName(content) {
            let icon = 'filetype_' + content.type;
            if(content.type === 'single') {
                switch(content.file.mimeType) {
                    case 'application/pdf':
                        icon += '_pdf';
                        break;
                    case 'image/jpg':
                    case 'image/jpeg':
                    case 'image/png':
                    case 'image/svg+xml':
                        icon += '_image';
                        break;
                    case 'video/mp4':
                        icon += '_video';
                        break;
                }
            }
            return icon;
        },
        openFileActionOverlay(event) {
            if(!this.$store.state.libraryRightClickOverlay.elementSelector) {
                return;
            }
            const el = event.target.closest(this.$store.state.libraryRightClickOverlay.elementSelector);
            if(!el) {
                return;
            }
            event.preventDefault();
            let clickX = event.x;
            let clickY = event.y;
            const rightClickBox = document.getElementById("library-right-click-box");
            rightClickBox.style.display = "block";
            const boundingClient = rightClickBox.getBoundingClientRect();
            rightClickBox.style.display = "none";
            const boxWidth = boundingClient.width;
            const boxHeight = boundingClient.height;
            const windowWidth = window.innerWidth;
            const windowHeight = window.innerHeight;
            if((clickX + boxWidth) > windowWidth) {
                clickX -= boxWidth;
            }
            if((clickY + boxHeight) > windowHeight) {
                clickY -= boxHeight;
            }
            this.$store.state.libraryRightClickOverlay = {
                id: el.dataset.contentId,
                visible: true,
                positionX: clickX,
                positionY: clickY,
                elementSelector: this.$store.state.libraryRightClickOverlay.elementSelector,
            }
        },
        unstringifyBuffer(buffer) {
            const content = this.unstringifyBufferAsBlob(buffer);
            return URL.createObjectURL(content);
        },
        unstringifyBufferAsBlob(buffer) {
            let content;
            if(buffer.mimeType) {
                content = new Blob([new Uint8Array(buffer.data)], {type: buffer.mimeType});
            } else {
                content = new Blob([new Uint8Array(buffer.data)]);
            }
            return content;
        }
    },
}